import {
    REQUEST_FAVORITES,
    FETCH_FAVORITES_SUCCESS,
    FETCH_FAVORITES_FAILURE,
    SELECT_FAVORITES,
    RESET_CURRENT_FAVORITES,
    REQUEST_FAVORITES_DETAIL,
    FETCH_FAVORITES_DETAIL_SUCCESS,
    FETCH_FAVORITES_DETAIL_FAILURE,
    REQUEST_ADDING_FAVORITE,
    ADD_FAVORITE_SUCCESS,
    ADD_FAVORITE_FAILURE,
    REQUEST_DELETE_FAVORITE,
    DELETE_FAVORITE_SUCCESS,
    DELETE_FAVORITE_FAILURE,
    REQUEST_FAVORITE_LIST,
    FETCH_FAVORITE_LIST_SUCCESS,
    FETCH_FAVORITE_LIST_FAILURE,
    REQUEST_SAVE_FAVORITE_LIST,
    SAVE_FAVORITE_LIST_SUCCESS,
    SAVE_FAVORITE_LIST_FAILURE,
} from '../actions/type'

const INITIAL_STATE = {
    all: [],
    currentFavorites: null,
    currentFavoritesDetail: null,
    isLoading: false,
    error: null,
    favoritesAreLoading: false,
    favoritesError: null,
    isCreating: false,
    createError: null,
    created: false,
    isEditing: false,
    editError: null,
    edited: false,
    favoriteList: [],
    favoriteListIsLoading: false,
    favoriteListError: null,
    saveFavoriteListSuccess: null,
    saveFavoriteListError: null,
};


export default function (state = INITIAL_STATE, action) {
    switch (action.type) {

        // Favorites action handlers
        case REQUEST_FAVORITES:
            return { ...state, error: null, isLoading: true };
        case FETCH_FAVORITES_SUCCESS:
            return { ...state, all: action.payload.data, error: null, isLoading: false };
        case FETCH_FAVORITES_FAILURE:
            const error = action.payload || { message: action.payload.message };
            return { ...state, all: [], error: error, isLoading: false };
        case SELECT_FAVORITES:
            return { ...state, currentFavorites: action.payload };
        case RESET_CURRENT_FAVORITES:
            return { ...state, currentFavorites: null };
        case REQUEST_FAVORITES_DETAIL:
            return { ...state, favoritesError: null, favoritesAreLoading: true };
        case FETCH_FAVORITES_DETAIL_SUCCESS:// return list of posts and make loading = false
            return { ...state, currentFavoritesDetail: action.payload.data, favoritesError: null, favoritesAreLoading: false };
        case FETCH_FAVORITES_DETAIL_FAILURE:// return error and make loading = false
            const favoritesError = action.payload || { message: action.payload.message };//2nd one is network or server down errors
            return { ...state, all: [], favoritesError: favoritesError, favoritesAreLoading: false };
        case REQUEST_ADDING_FAVORITE:
            return { ...state, error: null, isLoading: true};
        case ADD_FAVORITE_SUCCESS:
            return { ...state, isLoading: false };
        case ADD_FAVORITE_FAILURE:
            return { ...state, error: error, isLoading: false };
        case REQUEST_DELETE_FAVORITE:
            return {...state, error: null, isLoading: true};
        case DELETE_FAVORITE_SUCCESS:
            return {...state, isLoading: false};
        case DELETE_FAVORITE_FAILURE:
            return {...state, error: error, isLoading: false};
        case REQUEST_FAVORITE_LIST:
            return { ...state, favoriteListIsLoading: true, favoriteList: [], favoriteListError: null };
        case FETCH_FAVORITE_LIST_SUCCESS:
            return { ...state, favoriteListIsLoading: false, favoriteList: action.payload.data };
        case FETCH_FAVORITE_LIST_FAILURE:
            const favoriteListError = action.payload.data || { message: action.payload.message };
            return { ...state, favoriteListIsLoading: false, favoriteListError };
        case REQUEST_SAVE_FAVORITE_LIST:
            return { ...state, saveFavoriteListSuccess: null, saveFavoriteListError: null };
        case SAVE_FAVORITE_LIST_SUCCESS:
            return { ...state, saveFavoriteListSuccess: true };
        case SAVE_FAVORITE_LIST_FAILURE:
            return { ...state, saveFavoriteListError: true };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./master/jsx/reducers/favorites_reducer.js